import BasePlayer from 'services/sports/mlb/player/player';
import Action from 'actions';
import Const from 'constants';

export default class Player extends BasePlayer {
    afterGettingPlayers({incomingValues: {dispatch}}) {
        const {playersData} = Action.getState();
        const {
            mlbFilters,
            filters: {playerConfirmed},
        } = playersData;

        this.fillTeamsData(dispatch);

        dispatch(Action.set('HittersOrder', mlbFilters.order));
        dispatch(Action.set('PlayerConfirmedFilter', playerConfirmed));
    }

    getPlayerById({incomingValues: {id}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const players = preparedPlayers.groupedBy.playerId();

        const [playerId, positionKey] = id.split(Const.LP_ITEM_DELIMITER);

        const player = {...players[playerId]};

        player.position = positionKey ? Number(positionKey) : Number(player.position[0]);

        return player;
    }
}
